import { NgModule } from '@angular/core';
import { SelectComponent } from './select.component';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SelectComponent],
  imports: [CommonModule, FormsModule, DropdownModule, MultiSelectModule],
  exports: [SelectComponent],
})
export class SelectComponentModule {}
